import { Component, inject, model } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type ModalCancellationMonitoringReturnType = string;

@Component({
  selector: 'app-modal-cancellation-monitoring',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatDialogClose,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './modal-cancellation-monitoring.component.html',
  styleUrl: './modal-cancellation-monitoring.component.scss',
})
export class ModalCancellationMonitoringComponent {
  reason = model<ModalCancellationMonitoringReturnType>('');

  readonly dialogRef = inject<
    MatDialogRef<
      ModalCancellationMonitoringComponent,
      ModalCancellationMonitoringReturnType
    >
  >(
    MatDialogRef<
      ModalCancellationMonitoringComponent,
      ModalCancellationMonitoringReturnType
    >,
  );

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close(this.reason());
  }
}
